import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { Workbook } from '../../../models/SearchResultTypes';
import { DetailsTooltipStyles } from '../../tooltips/DetailsTooltipStyles';
import { BasicField } from '../../tooltips/elements/BasicField';
import { MarkupField } from '../../tooltips/elements/MarkupField';
import { Name } from '../../tooltips/elements/Name';
import { Tags } from '../../tooltips/elements/Tags';
import { Timestamp } from '../../tooltips/elements/Timestamp';
import { ContentTooltipProps, TooltipDescriptionTestId } from '../../tooltips/TooltipHelper';

export function WorkbookTooltip(props: ContentTooltipProps): JSX.Element {
  const { content } = props;
  const workbookContent = content as Workbook;
  return (
    <div role={'tooltip'}>
      <Name name={content.name} />
      {workbookContent.description && (
        <MarkupField
          markup={workbookContent.description}
          testId={TooltipDescriptionTestId}
          extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}
        />
      )}
      {workbookContent.tags && <Tags tags={workbookContent.tags} />}
      {workbookContent.hitsTotal !== undefined && <BasicField name={Messages.views()} value={workbookContent.hitsTotal} />}
      {workbookContent.modifiedTime && <Timestamp label={Messages.modified()} value={new Date(workbookContent.modifiedTime)} />}
    </div>
  );
}
